<template>
  <footer class="main-footer">
    <strong>Copyright &copy; {{ currentYear }} <a href="https://adminlte.io/">VNPT Đồng Tháp</a>.</strong>
    <div class="float-right d-none d-sm-inline-block">
      <b>Version</b> 1.0
    </div>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter',
  data() {
    return {
      currentYear: new Date().getFullYear()
    }
  },
}
</script>

<style>

</style>